/** Shared presentation geometry for lobbed projectiles and their trajectory preview. */
export const lobHeight = (progress: number) => Math.sin(Math.PI * Math.max(0, Math.min(1, progress))) * 40
